const FORMAT_SIZE_IN_MM = {
  "A4-portrait": {
    height: 297,
    width: 210
  },
  "A4-landscape": {
    height: 210,
    width: 297
  }
};

/**
 * Collection of common design sizes used in print layouts.
 *
 * @NB the resulting pixels should always round to integers if consistent
 *     formatting is required across all browsers.
 */
const DESIGN_SIZES = {
  /**
   * this format ensures that if one pixel is specified, then the resulting UI
   * will be a single pixel as well.
   */
  ONE_TO_ONE: format => format === "A4-landscape" ? {
    height: 793.7008,
    width: 1122.5197
  } : {
    height: 1122.5197,
    width: 793.7008
  }
};

export { DESIGN_SIZES, FORMAT_SIZE_IN_MM };
//# sourceMappingURL=constants.js.map
